import React, { FC } from 'react'
import { convertSizeMeasurement } from './helper'
import { useSelector } from 'react-redux'
import { getUserPreferencesMeasurementUnit } from 'selectors/user/cookie'
import { DimensionUnits } from './types'

type DimensionsUnitProps = {
  dimensions: DimensionUnits
  isDepthVisible?: boolean
  fromUnit?: 'in' | 'cm'
}

const DimensionsUnit: FC<DimensionsUnitProps> = ({
  dimensions,
  isDepthVisible = true,
  fromUnit = 'cm',
}) => {
  const userPreferencesMeasurementUnit = useSelector(getUserPreferencesMeasurementUnit)

  if (!dimensions) {
    return null
  }

  const width = fromUnit === 'cm' ? dimensions?.widthInCentimeters : dimensions?.widthInInches
  const height = fromUnit === 'cm' ? dimensions?.heightInCentimeters : dimensions?.heightInInches
  const depth = fromUnit === 'cm' ? dimensions?.depthInCentimeters : dimensions?.depthInInches

  const depthString = isDepthVisible
    ? ` x ${convertSizeMeasurement({
        size: depth,
        fromUnit,
        toUnit: userPreferencesMeasurementUnit,
      })} ${userPreferencesMeasurementUnit}`
    : userPreferencesMeasurementUnit

  return (
    <span data-type='dimensions-unit'>
      {`${convertSizeMeasurement({
        size: width,
        fromUnit,
        toUnit: userPreferencesMeasurementUnit,
      })} x ${convertSizeMeasurement({
        size: height,
        fromUnit,
        toUnit: userPreferencesMeasurementUnit,
      })} ${depthString}`}
    </span>
  )
}

export default DimensionsUnit
